import { getResizeImage } from '~/components/Image';

type Props = {
  imageUrl: string;
};

export function MainImage({ imageUrl }: Props) {
  return (
    <img
      src={getResizeImage({
        src: imageUrl,
        width: 640,
      })}
      fetchPriority="high"
      alt="이벤트 배너"
    />
  );
}
